import { Component, OnInit, forwardRef, inject } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ReportOption } from 'app/core/models/report-option.model';
import { ReportAbstractOptionComponent } from 'app/shared/components/report-abstract-option/report-abstract-option.component';
import { CaptureStatusAndReason, CaptureStatusAndReasonSelectComponent } from '../capture-status-and-reason-select/capture-status-and-reason-select.component';
import { CaptureService } from 'app/core/services/capture.service';

export class ReportCaptureStatusAndReasonOption implements ReportOption {
  value: CaptureStatusAndReason[];

  constructor(value) {
    this.value = value;
  }

  toPostData(options = { paramName: 'statusAndReasons' }) {
    return { [options.paramName]: this.buildStatusAndReasonParams() };
  }

  private buildStatusAndReasonParams() {
    return this.value.reduce(
      (accumulator, currentValue) => {
        accumulator[currentValue.status] ||= [];
        accumulator[currentValue.status].push(currentValue.reason);
        return accumulator;
      },
      {}
    )
  }
}

@Component({
    selector: 'app-report-capture-status-and-reason-option',
    templateUrl: './report-capture-status-and-reason-option.component.html',
    styleUrls: ['./report-capture-status-and-reason-option.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => ReportCaptureStatusAndReasonOptionComponent),
        },
    ],
    imports: [CaptureStatusAndReasonSelectComponent]
})
export class ReportCaptureStatusAndReasonOptionComponent extends ReportAbstractOptionComponent implements OnInit {
  private captureService = inject(CaptureService);

  selectedCaptureStatusAndReasons;
  availableCaptureStatusAndReasons: CaptureStatusAndReason[];

  ngOnInit() {
    this.availableCaptureStatusAndReasons = this.captureService.statusAndReasonsForSelect() as CaptureStatusAndReason[];
  }

  onModelChange(_model: CaptureStatusAndReason[]) {
    this.model = new ReportCaptureStatusAndReasonOption(this.selectedCaptureStatusAndReasons);
    this.onChangeFn(this.model);
  }
}
